import { render, staticRenderFns } from "./ApplicantEdit.vue?vue&type=template&id=d10c554c&scoped=true&"
import script from "./ApplicantEdit.vue?vue&type=script&lang=javascript&"
export * from "./ApplicantEdit.vue?vue&type=script&lang=javascript&"
import style0 from "./ApplicantEdit.vue?vue&type=style&index=0&id=d10c554c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d10c554c",
  null
  
)

export default component.exports